/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, OnInit} from '@angular/core';
import {ObsoleteRecordsInput} from '../../../core/models/obsolete-records-input.model';
import {EngDtlService} from '../../../services/eng-dtl.service';
import {MarketingDivisionService} from '../../../services/marketing-division.service';
import {RemoveObsoleteVehicleService} from '../../../services/remove-obsolete-vehicle.service';
import {TranDtlService} from '../../../services/tran-dtl.service';

@Component({
    selector: 'app-shared-remove-obsolete-records',
    templateUrl: './shared-remove-obsolete-records.component.html',
    styleUrls: ['./shared-remove-obsolete-records.component.scss'],
    standalone: false
})
export class SharedRemoveObsoleteRecordsComponent implements OnInit {
  // Inputs to pass to the RemoveObsoletesRecordsComponent
  obsoleteVehiclesInput: ObsoleteRecordsInput;
  obsoleteEnginesInput: ObsoleteRecordsInput;
  obsoleteTransmissionsInput: ObsoleteRecordsInput;
  obsoleteMarketDivisionsInput: ObsoleteRecordsInput;

  constructor(private readonly obsoleteVehiclesService: RemoveObsoleteVehicleService,
              private readonly obsoleteEnginesService: EngDtlService,
              private readonly obsoleteTransmissionsService: TranDtlService,
              private readonly obsoleteMarketDivisionsService: MarketingDivisionService) {
  }

  ngOnInit() {
    this.setObsoleteRecordsInputs();
  }

  /**
   * Sets the inputs to pass to the template.
   */
  setObsoleteRecordsInputs(): void {
    this.obsoleteVehiclesInput = {
      confirmationMessage: 'Are you sure you want to remove all obsolete vehicles?',
      successMessage: 'Successfully removed obsolete vehicles',
      headerMessage: 'Remove Obsolete Vehicles',
      noDataMessage: 'No obsolete vehicles',
      service: this.obsoleteVehiclesService,
      columnHeaders: [
        {name: 'BRANDFAM', label: 'BRANDFAM'},
        {name: 'PLNGMKT', label: 'PLNGMKT'},
        {name: 'MKTDIV', label: 'MKTDIV'},
        {name: 'BRAND', label: 'BRAND'},
        {name: 'LBRAND', label: 'LBRAND'},
        {name: 'PRGMCODE', label: 'PRGMCODE'},
        {name: 'STYLECODE', label: 'STYLECODE'},
        {name: 'BODYSTYLE', label: 'BODYSTYLE'}
      ]
    };

    this.obsoleteTransmissionsInput = {
      confirmationMessage: 'Are you sure you want to remove all obsolete transmission configurations?',
      successMessage: 'Successfully removed obsolete transmission configurations',
      headerMessage: 'Remove Obsolete Transmission Configurations',
      noDataMessage: 'No obsolete transmission configurations',
      service: this.obsoleteTransmissionsService,
      columnHeaders: [
        {name: 'id', label: 'ID'},
        {name: 'tranFam', label: 'TRANFAM'},
        {name: 'tranRpo', label: 'TRANRPO'},
        {name: 'tranName', label: 'TRANNAME'},
        {name: 'tranSpeed', label: 'TRANSPEED'},
        {name: 'tranType', label: 'TRANTYPE'},
        {name: 'driveType', label: 'DRIVETYPE'}
      ]
    };

    this.obsoleteEnginesInput = {
      confirmationMessage: 'Are you sure you want to remove all obsolete engine configurations?',
      successMessage: 'Successfully removed obsolete engine configurations',
      headerMessage: 'Remove Obsolete Engine Configurations',
      noDataMessage: 'No obsolete engine configurations',
      service: this.obsoleteEnginesService,
      columnHeaders: [
        {name: 'id', label: 'ID'},
        {name: 'engFam', label: 'ENGFAM'},
        {name: 'engRpo', label: 'ENGRPO'},
        {name: 'batRpo', label: 'BATRPO'},
        {name: 'boost', label: 'BOOST'},
        {name: 'engCam', label: 'ENGCAM'},
        {name: 'engPwr', label: 'ENGPWR'},
        {name: 'engDsp', label: 'ENGDSP'},
        {name: 'engCyl', label: 'ENGCYL'},
        {name: 'engTorq', label: 'ENGTORQ'},
        {name: 'vfuel', label: 'VFUEL'},
        {name: 'injection', label: 'INJECTION'},
        {name: 'elecRpo', label: 'ELECRPO'},
        {name: 'elecFam', label: 'ELECFAM'},
        {name: 'elecDesc', label: 'ELECDESC'},
        {name: 'cellFam', label: 'CELLFAM'},
        {name: 'batDesc', label: 'BATDESC'},
        {name: 'priDrvDesc', label: 'PRIDRVDESC'},
        {name: 'priDrvRpo', label: 'PRIDRVRPO'},
        {name: 'secDrvDesc', label: 'SECDRVDESC'},
        {name: 'secDrvRpo', label: 'SECDRVRPO'}
      ]
    };

    this.obsoleteMarketDivisionsInput = {
      confirmationMessage: 'Are you sure you want to remove all obsolete Market Divisions?',
      successMessage: 'Successfully removed obsolete Market Divisions',
      headerMessage: 'Remove Obsolete Market Divisions',
      noDataMessage: 'No obsolete market divisions',
      service: this.obsoleteMarketDivisionsService,
      columnHeaders: [{name: 'mktDiv', label: 'Market Division'}]
    };
  }

}
